import React, { Fragment, useEffect } from "react";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";
import { fetchDeleteClaimReward, fetchAwardOrder } from "../actions/award";
import {
  statusRenderRewawrd, statusSectorRender,
  statusTypeRender,
} from "../utils/cellRenderTable";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const AwardOrder = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "rewards";
  const pageType = "Order";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { awardOrderList } = useSelector((state) => state.awardReducer);

  useEffect(() => {
    dispatch(fetchAwardOrder());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (
      !params.data ||
      !params.data.id ||
      !params.data.name ||
      !params.data.lastName ||
      !params.data.rewardName ||
      !params.data.status
    )
      return null;
    if (params.data.status == "CANCELLED") return null;
    return (
      <ButtonColumn
        deleteItemId={params?.data?.id}
        deleteItemTitle={`${params?.data?.rewardName}`}
        status={params.data.status}
        // approveItemTitle={`${params.data.rewardName} za korisnika ${params.data.name} ${params.data.lastName}`}
        // rejectItemTitle={`${params.data.rewardName} za korisnika ${params.data.name} ${params.data.lastName}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (id) => {
    dispatch(fetchDeleteClaimReward(id));
  };

  const columnDefs = [
    {
      headerName: t("awardOrder.id"),
      field: "id",
      filter: "agTextColumnFilter",
      width: 320,
    },
    {
      headerName: t("awardOrder.countryName"),
      field: "countryName",
      filter: "agSetColumnFilter",
    },
    {
      headerName: t("awardOrder.rewardName"),
      field: "rewardName",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("awardOrder.points"),
      field: "points",
      filter: "agTextColumnFilter",
      width: 180,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("awardOrder.quantity"),
      field: "quantity",
      filter: "agTextColumnFilter",
      width: 180,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("awardOrder.name"),
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 180,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("awardOrder.lastName"),
      field: "lastName",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("awardOrder.companyName"),
      field: "companyName",
      filter: "agSetColumnFilter",
      flex: 1,
      minWidth: 220,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("awardOrder.storeName"),
      field: "storeName",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("awardOrder.sectorName"),
      field: "sector",
      filter: "agSetColumnFilter",
      cellRenderer: statusSectorRender,
      valueGetter: (params) => {
        if (!params?.data || !params?.data?.sector) return null;
        switch (params?.data?.sector) {
          case "DEVICE_FOR_HOUSE":
            return "Aparati za kuću";
          case "TV_AUDIO":
            return "TV/Audio";
          case "DEVICE_FOR_HOUSE_AND_TV_AUDIO":
            return "Aparati za kuću i TV/Audio";
          default:
            return "";
        }
      },
    },
    {
      headerName: "Tip nagrade",
      field: "type",
      filter: "agSetColumnFilter",
      cellRenderer: statusTypeRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.type) return null;
        return t(`awardList.${params.data.type}`);
      },
      width: 250,
      cellStyle: { display: "flex", alignItems: "center" },
    },
    {
      headerName: t("awardOrder.status"),
      field: "status",
      filter: "agSetColumnFilter",
      width: 150,
      cellRenderer: statusRenderRewawrd,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "PENDING":
            return t("awardOrder.pending");
          case "APPROVED":
            return t("awardOrder.approved");
          case "CANCELLED":
            return t("awardOrder.cancelled");
          case "REJECTED":
            return t("awardOrder.rejected");
          default:
            return "";
        }
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("awardOrder.createdAt"),
      field: "createdAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 60,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={awardOrderList}
        columnDefs={columnDefs}
        buttonLink={`/award-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey={"award-main-list"}
      />
    </Fragment>
  );
};

export default AwardOrder;
